import React from 'react';
import PropTypes from 'prop-types';
import { processOrders } from './utils';
import { Grid } from 'src/components/HTKit/Grid';
import NoOrders from './NoOrders';
import { OrderCard, WorkflowCard } from './OrderCard';
import styles from './styles.scss';

export const OrdersList = ({ orders, toggleSiteNav }) => {
  if (!orders?.length) {
    return <NoOrders onCtaButtonClick={toggleSiteNav} />;
  }

  const { futureOrders, pastOrders } = processOrders(orders);

  const renderOrderList = (ordersToRender) => {
    if (!ordersToRender?.length) return <NoOrders onCtaButtonClick={toggleSiteNav} />;

    return ordersToRender.map(({ order, isWorkflowOrder, isPastOrder }, index) => (
      <div key={index} className={styles.orderCard}>
        {isWorkflowOrder ? (
          <WorkflowCard order={order} />
        ) : (
          <OrderCard order={order} isPastOrder={isPastOrder} />
        )}
      </div>
    ));
  };

  return (
    <Grid.Row>
      <Grid.Column sm={4} md={8} lgOffset={3} lg={6} classes={styles.ordersContainer}>
        {futureOrders.length > 0 && (
          <div className={styles.ordersBlock}>
            <h4 className={styles.ordersHeader}>Upcoming</h4>
            {renderOrderList(futureOrders)}
          </div>
        )}
        {pastOrders.length > 0 && (
          <div className={styles.ordersBlock}>
            <h4 className={styles.ordersHeader}>Past</h4>
            {renderOrderList(pastOrders)}
          </div>
        )}
      </Grid.Column>
    </Grid.Row>
  );
};

OrdersList.propTypes = {
  orders: PropTypes.array.isRequired,
  toggleSiteNav: PropTypes.func.isRequired,
};
